module.exports = __webpack_public_path__ + "images/park-west-9d35ab128b476d45c0c1cf98538683cb.jpg";